<template>
    <v-dialog v-model="isModalShowing" persistent width="700">
        <template v-slot:activator="{ on }">
            <span v-on="on">
                <slot />
            </span>
        </template>
        <v-card data-test="confirm-cancel-modal">
            <v-card-title>
                <h2 class="headline">{{ $t('modals.endTrackingModal.title') }}</h2>
            </v-card-title>
            <v-card-text>
                <p>{{ $t('modals.endTrackingModal.body') }}</p>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="cancelModal">{{ $t('modals.endTrackingModal.cancel') }}</v-btn>
                <v-spacer />
                <!-- Show download button only if screen width is greater than 960px -->
                <v-btn v-if="chatInitiated && isScreenLarge" @click="triggerDownload" color="primary">{{ $t('modals.endTrackingModal.downloadChat') }}</v-btn>
                <v-btn @click="reset" color="error" data-test="confirm-end-tracking-button">{{ $t('modals.endTrackingModal.endTracking') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue'
import store from '@/store'
import { editUser } from '@/services/users'
import { eventBus } from "@/main";

export default Vue.extend({
    data(): { isModalShowing: boolean; screenWidth: number } {
        return {
            isModalShowing: false,
            screenWidth: window.innerWidth
        }
    },
    created() {
        window.addEventListener('resize', this.updateScreenWidth)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateScreenWidth)
    },
    methods: {
        updateScreenWidth() {
            this.screenWidth = window.innerWidth
        },
        triggerDownload() {
            eventBus.$emit('downloadChatConvo')
        },
        openModal() {
            this.isModalShowing = true
        },
        cancelModal() {
            this.isModalShowing = false
        },
        async reset() {
            if (!store.state.authentication.currentUser.hasSeenWalkthrough) {
                const userId = store.state.authentication.currentUser.id
                await editUser(userId, { hasSeenWalkthrough: true })
                await store.dispatch('authentication/getCurrentUser')
            }

            store.dispatch('location/saveLastWeather')
            store.dispatch('location/triggerAIChatSummary')
            await this.uploadToS3()

            eventBus.$emit('clearGeoJsonLayer')
            eventBus.$emit('restartCT')
            await store.dispatch('location/reset')
            window.location.reload()
        },
        async uploadToS3() {
            if ([
                    'Florida Fish and Wildlife Conservation Commission',
                    'Florida Fish & Wildlife – Tallahassee Dispatch',
                    'Florida Fish & Wildlife – Jacksonville Dispatch',
                    'Florida Fish & Wildlife – Sanford Dispatch',
                    'Florida Fish & Wildlife – Lake Worth Dispatch',
                    'i911 Inc.'
                ].includes(this.teamName)) {
                await store.dispatch('location/uploadToS3');
            }
        }
    },
    computed: {
        chatInitiated() {
            return store.state.location.chatInitiated
        },
        isScreenLarge(): boolean {
            return this.screenWidth > 960
        },
        teamName() {
            return store.state.authentication.teams[0].teamName
        }
    }
})
</script>